import { ReactNode } from "react";
import { AuthContextProvider } from "./auth-context";
import { LessonProvider } from "./lesson-context";
import { Toaster } from "sonner";
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
  isCancelledError,
} from "@tanstack/react-query";
import { LanguageProvider } from "./language-context";
import { SubscriptionProvider } from "./SubscriptionProvider";
import { CompletionProvider } from "./PointsContext";
import { AxiosError, isAxiosError } from "axios";
import { toast } from "sonner";

export const Providers = ({ children }: { children: ReactNode }) => {
  const handleGlobalError = (error: any) => {
    console.log("global ERROR");
    if (isCancelledError(error)) {
      return;
    }
    if (isAxiosError(error)) {
      console.error("Axios Error:", error.message);

      if (error.response?.status === 401) {
        toast.error("Session expired. Please log in again.", {
          id: "session-expired-toast",
          richColors: true,
        });

        window.location.href = "/login";
      }
    } else {
      // Handle other types of errors if necessary
      console.error("An unexpected error occurred:", error);
    }
  };
  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: handleGlobalError,
    }),
    mutationCache: new MutationCache({
      onError: handleGlobalError,
    }),
    defaultOptions: {
      queries: {
        // It's a good idea to disable retries for 401 errors
        retry: (failureCount, error) => {
          if (isAxiosError(error) && error.response?.status === 401) {
            return false; // Do not retry on 401
          }
          return failureCount < 3; // Retry other errors up to 3 times
        },
      },
    },
  });
  return (
    <>
      <Toaster position="top-right" richColors />
      <QueryClientProvider client={queryClient}>
        <AuthContextProvider>
          <SubscriptionProvider>
            <LanguageProvider>
              <LessonProvider>
                <CompletionProvider>{children}</CompletionProvider>
              </LessonProvider>
            </LanguageProvider>
          </SubscriptionProvider>
        </AuthContextProvider>
      </QueryClientProvider>
    </>
  );
};
